import { useSaveQuestionChangeStore } from "../store/useSaveQuestionChangeStore";

export const useSaveQuestionChangesCheck = ({
  skipCheck = false,
}: {
  skipCheck?: boolean;
}) => {
  const isOpen = useSaveQuestionChangeStore((state) => state.isOpen);
  const close = useSaveQuestionChangeStore((state) => state.cancel);
  const openModal = useSaveQuestionChangeStore((state) => state.openModal);
  const confirm = useSaveQuestionChangeStore((state) => state.confirm);

  return {
    isOpen,
    close,
    confirm,
    confirmAndRun: (action: (actionType?: Number) => void) => {
      if (skipCheck) {
        return action();
      }
      openModal(action);
    },
  };
};
